import { APIUrls } from "../../Constants/ApiUrls";
// import { IUser } from "../../Models/IUser"; //Fix Warning Complaint Code:071225
import { IUserEdit, IUserFieldsEdit } from "../../Models/IUser";
import { AjaxService, IAPIRequest, IAPIResponse } from "../AjaxService";

const UsersController = {
  GetUsersList: async (callback?: (response: IAPIResponse) => void) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.ENDUSERS.ENDUSERS_GET_LIST;
    request.allowApiCache = true;
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
  ChangeUserPassword: async (
    oldPassword: string,
    newPassword: string,
    callback?: (response: IAPIResponse) => void
  ) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.ENDUSERS.CHANGE_PASSWORD;
    request.method = "POST";
    request.payload = { oldPassword, newPassword };
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
  // fresh: dopo una modifica si rilegge dal server, senza la copia in cache
  GetUsers: async (callback?: (response: IAPIResponse) => void, fresh = false) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.ENDUSERS.ENDUSERS_GET;
    request.allowApiCache = !fresh;
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
  GetUsersRoles: async (callback?: (response: IAPIResponse) => void) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.ENDUSERS.ENDUSERS_GET_ROLES;
    request.allowApiCache = true;
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
  CreateOrUpdateUser: async (
    user: IUserEdit,
    callback?: (response: IAPIResponse) => void
  ) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.ENDUSERS.ENDUSERS_UPDATE;
    request.method = "POST";
    request.payload = user;
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
  UpdateUserFields: async (
    fields: IUserFieldsEdit,
    callback?: (response: IAPIResponse) => void
  ) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.ENDUSERS.ENDUSERS_UPDATE;
    request.method = "POST";
    request.payload = fields;
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
  AddUserRole: async (
    userId: number,
    roleId: number,
    callback?: (response: IAPIResponse) => void
  ) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.ENDUSERS.ENDUSERS_UPDATE_ROLE;
    request.method = "POST";
    request.payload = {
      userId,
      roleId,
    };
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
  DeleteUserRole: async (
    userId: number,
    roleId: number,
    callback?: (response: IAPIResponse) => void
  ) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.ENDUSERS.ENDUSERS_DELETE_ROLE;
    request.method = "DELETE";
    request.payload = {
      userId,
      roleId,
    };
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
};

export default UsersController;
